// UX-014: a legacy path answers with a redirect to its canonical path, keeping
// the query string and hash so a bookmark such as /workflow?tab=reviews still
// lands on the same view.

import { Navigate, useLocation } from 'react-router-dom'
import { useWorkspace } from '../../contexts/WorkspaceContext'
import { preferencesPathFor } from '../../config/navigation'

export function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation()
  return <Navigate to={`${to}${search}${hash}`} replace />
}

/** /preferences belonged to two screens; send it to the one the person is in. */
export function LegacyPreferencesRedirect() {
  const { active } = useWorkspace()
  return <LegacyRedirect to={preferencesPathFor(active.kind)} />
}
